"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const styles_1 = require("../styles");
const ButtonBase_1 = __importDefault(require("./ButtonBase"));
const Text_1 = __importDefault(require("./Text"));
const handleTextColor = (variant, color, disabled) => {
    if (disabled) {
        return textColors.disabled;
    }
    else {
        if (color === 'default') {
            return textColors.default;
        }
        else {
            if (variant === 'outlined') {
                if (color === 'primary') {
                    return textColors.primaryOutline;
                }
                else {
                    return textColors.secondaryOutlined;
                }
            }
        }
        return textColors.contained;
    }
};
const handleButtonStyle = (variant, color, disabled) => {
    if (disabled) {
        return colorBasedStyle.disabled;
    }
    else {
        if (color === 'default') {
            return colorBasedStyle.default;
        }
        else {
            if (variant === 'contained') {
                if (color === 'primary') {
                    return colorBasedStyle.primary;
                }
                return colorBasedStyle.secondary;
            }
            else if (variant === 'outlined') {
                if (color === 'primary') {
                    return colorBasedStyle.primaryOutline;
                }
                return colorBasedStyle.secondaryOutline;
            }
        }
    }
};
const Button = ({ variant = 'contained', color = 'default', disabled = false, children, onPress, testID, style, text, linkUrl, screenName, params, accessibilityLabel, }) => {
    return (react_1.default.createElement(ButtonBase_1.default, { to: linkUrl, accessibilityLabel: accessibilityLabel, screenName: screenName, params: params, testID: testID, disabled: disabled, onPress: onPress, style: react_native_1.StyleSheet.flatten([styles.container, handleButtonStyle(variant, color, disabled), style]) },
        !!text && (react_1.default.createElement(Text_1.default, { variant: "mediumBody", margin: "none", style: react_native_1.StyleSheet.flatten([handleTextColor(variant, color, disabled)]) }, text)),
        children));
};
exports.default = Button;
const styles = react_native_1.StyleSheet.create({
    container: {
        borderWidth: styles_1.getSpacing('border'),
        borderColor: styles_1.Colors.border,
        borderRadius: styles_1.getRadius(),
        alignItems: 'center',
        justifyContent: 'center',
        height: styles_1.getSpacing('row'),
    },
});
const colorBasedStyle = react_native_1.StyleSheet.create({
    default: {
        backgroundColor: styles_1.Colors.background,
        borderColor: styles_1.Colors.background,
    },
    primary: {
        backgroundColor: styles_1.Colors.primary,
        borderColor: styles_1.Colors.primary,
    },
    secondary: {
        backgroundColor: styles_1.Colors.secondary,
        borderColor: styles_1.Colors.secondary,
    },
    primaryOutline: {
        backgroundColor: styles_1.Colors.card,
        borderColor: styles_1.Colors.primary,
    },
    secondaryOutline: {
        backgroundColor: styles_1.Colors.card,
        borderColor: styles_1.Colors.secondary,
    },
    disabled: {
        backgroundColor: styles_1.Colors.white,
        borderColor: styles_1.Colors.border,
    },
});
const textColors = react_native_1.StyleSheet.create({
    default: {
        color: styles_1.Colors.black,
    },
    contained: {
        color: styles_1.Colors.white,
    },
    secondaryOutlined: {
        color: styles_1.Colors.secondary,
    },
    primaryOutline: {
        color: styles_1.Colors.primary,
    },
    disabled: {
        color: styles_1.Colors.darkGray,
    },
});
